// krokem-cart.js
// Notes:
// - This version centralizes cycle/holiday/vacation logic and removes scattered date hacks.
// - It enforces the Friday 12:00 AM → 9:00 AM (Miami) store-closed block at checkout time.

$(document).ready(function () {

  // Menu cycle closes every Friday at 3:00 PM store time (Miami)
  const CYCLE_CLOSE = {
    day: 5,   // Friday (0=Sun)
    hour: 9  // 9 AM
  };

  // Store time offset in hours (Miami is usually UTC-5 with DST; you were using UTC-4)
  // Keep as you had it to avoid changing behavior unexpectedly.
  const STORE_UTC_OFFSET = -4;

  // Vacation = the cycle lasts longer than 7 days (2 or 3 weeks).
  // Example: 2 weeks => weeks: 2 (close moves 7 days further)
  // Example: 3 weeks => weeks: 3 (close moves 14 days further)
  const VACATION = {
    enabled: false,
    from: '2025-12-26',
    to:   '2026-01-15'
  };

  // PERMANENT: Sunday pickup is disabled for ALL cycles (Friday pickup only).
  // Set back to false to re-enable Sunday pickup globally.
  const DISABLE_SUNDAY_PICKUP_ALWAYS = true;

  // Pickup overrides per cycle: control Friday and Sunday independently.
  // Key = cycle close date (YYYY-MM-DD). Value = { friday: bool, sunday: bool }
  // true = available, false = disabled. If a cycle is not listed, both days are available.
  // NOTE: DISABLE_SUNDAY_PICKUP_ALWAYS above wins over any sunday:true here.
  const PICKUP_OVERRIDES = {
    '2026-04-17': { friday: false, sunday: true }
  };

  // If you want to disable Shipping for specific cycles (rare), add cycle-close keys here.
  const DISABLE_SHIPPING_FOR_CYCLE_CLOSE = [
    // '2025-07-18'
  ];

  // TEMPORARY GLOBAL SWITCH: set to true to disable Shipping for the WHOLE store
  // (special weeks with pickup only). Set back to false to re-enable Shipping.
  const DISABLE_SHIPPING_THIS_WEEK = false;

  // TEMPORARY (2026-10-29, Delia): sale window with ONE fixed shipping date.
  // While set, the shipping date is always this Monday and the Friday 12-9 AM
  // "store closed" block is skipped. Set back to '' to return to the cycle engine.
  const FORCE_SHIPPING_DATE = '2026-11-09';
  // TEMPORARY (2026-10-29, Delia): shipping only, no Pickup option anywhere.
  const DISABLE_PICKUP_ALWAYS = true;

  // Holiday overrides: explicitly map resulting dates (no auto "+1 day" magic).
  // Keys are the computed date that would have been used (YYYY-MM-DD).
  // Values specify what to use instead.
  const HOLIDAY_OVERRIDES = {
    // Example: shipping would land on 2025-05-26, move it to 2025-05-27
    '2026-01-19': { shipping: '2026-01-20' },
    '2025-11-28': { pickup: '2025-11-27' }
  };

  // Product rules by handle
  const SHIPPING_ONLY_HANDLES = ['mystery-box', 'testbox'];
  const PICKUP_ONLY_HANDLES = ['bites-to-share', 'cinnamon-rolls', 'flantastic', 'reinita', 'popup-cinnamon-roll', 'popup-cinnamon-roll-box', 'cinnamon-roll-box-preorder', 'cinnamon-roll-mixed-box', 'cinnamon-roll-build-a-box'];

  // Pop-up event products: fixed pickup date + location (skip cycle engine, like mystery-box has its own ship date)
  const POPUP_EVENT = {
    'popup-cinnamon-roll': {
      dateKey: '2026-06-20',
      dateDisplay: 'SATURDAY JUN/20/2026 · 10 AM–6 PM',
      location: 'Haus Eleven Store'
    },
    'popup-cinnamon-roll-box': {
      dateKey: '2026-06-20',
      dateDisplay: 'SATURDAY JUN/20/2026 · 10 AM–6 PM',
      location: 'Haus Eleven Store'
    }
  };
  const POPUP_EVENT_HANDLES = Object.keys(POPUP_EVENT);

  // Minimum cookies exemption
  const MIN_COOKIES_EXEMPT_HANDLES = [ 'mystery-box', 'krokems-tasting-box'];

  // A BOX/PACK already contains its own cookies, so it must NEVER be blocked by
  // the "minimum 4 cookies" rule (that rule is only for loose cookies).
  // Auto-detects boxes by handle/title/type so a NEW box never breaks checkout
  // again, even if nobody remembers to add it to MIN_COOKIES_EXEMPT_HANDLES.
  function isBoxProduct(item) {
    if (!item) return false;
    if (MIN_COOKIES_EXEMPT_HANDLES.includes(item.handle)) return true;
    var hay = ((item.handle || '') + ' ' + (item.product_title || item.title || '')).toLowerCase();
    if (/\b(box|pack|kit|bundle|caja|dozen|assorted|tasting)\b/.test(hay)) return true;
    var pt = (item.product_type || '').toLowerCase();
    if (pt === 'box' || pt === 'bundle' || pt === 'bundle component') return true;
    return false;
  }

  // Products that show the warm-weather warning in the cart row
  const WARM_WEATHER_WARNING_HANDLES = ['reinita', 'flantastic'];
  const WARM_WEATHER_WARNING_MSG = 'HEADS UP: Due to warm weather, this cookie may arrive a little sticky or soft. Just pop it in the fridge for a couple of hours before enjoying!';

  // Globals used by existing UX logic
  window.TYBO_SHIPPING_ONLY = false;
  window.TYBO_PICKUP_ONLY = false;
  window.TYBO_ONLY_MYSTERY_BOX = false;
  window.TYBO_ONLY_POPUP = false;

  // =========================
  // TRACKING / SMALL UX
  // =========================
  $('.product-form__submit').click(function () { gtag('event', 'add_to_cart') });
  $('body').on('click', '.custom-tybo-checkout', function () { gtag('event', 'begin_checkout') });
  $('#create_customer').find(":button").click(function () { gtag('event', 'generate_lead') });

  // Block Enter submit in cart
  $('#cart').on('keyup keypress', function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      e.preventDefault();
      return false;
    }
  });

  // =========================
  // TIME / DATE HELPERS
  // =========================

  function getStoreTime() {
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    return new Date(utc + STORE_UTC_OFFSET * 3600000);
  }

  function pad2(n) { return String(n).padStart(2, '0'); }

  function toKeyYYYYMMDD(dateObj) {
    // Local-ish key based on store-time Date object
    const y = dateObj.getFullYear();
    const m = pad2(dateObj.getMonth() + 1);
    const d = pad2(dateObj.getDate());
    return `${y}-${m}-${d}`;
  }

  function parseKeyToDate(key) {
    // key: YYYY-MM-DD
    const [y, m, d] = key.split('-').map(Number);
    return new Date(y, m - 1, d, 0, 0, 0, 0);
  }

  function addDays(dateObj, days) {
    const d = new Date(dateObj);
    d.setDate(d.getDate() + days);
    return d;
  }

  function getFormattedDateParts(date) {
    const dayNames   = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const dayText = dayNames[date.getDay()];
    const mmText  = monthNames[date.getMonth()];
    const dd      = pad2(date.getDate());
    const yyyy = date.getFullYear();
    return { displayText: `${dayText} ${mmText}/${dd}/${yyyy}` };
  }

  // =========================
  // CYCLE ENGINE (single source of truth)
  // =========================

  function getBaseCycleClose(nowStore) {
    // Next Friday at 3 PM. If it's already past, go to next week.
    const now = new Date(nowStore);

    // Find the upcoming Friday
    const daysUntilFriday = (CYCLE_CLOSE.day - now.getDay() + 7) % 7;
    const close = new Date(now);
    close.setHours(CYCLE_CLOSE.hour, 0, 0, 0);
    close.setDate(now.getDate() + daysUntilFriday);

    // If today is Friday and it's >= 3 PM, or if we somehow got a close <= now, push a week
    if (close <= now) close.setDate(close.getDate() + 7);

    return close;
  }

  function getCycleClose(nowStore) {
    let base = getBaseCycleClose(nowStore);

    if (!VACATION.enabled || !VACATION.from || !VACATION.to) {
        return base;
    }

    const vacationStart = new Date(VACATION.from + 'T00:00:00');
    const vacationEnd   = new Date(VACATION.to   + 'T23:59:59');

    // If the normal cycle close falls inside vacation,
    // move it to the first valid Friday AFTER vacation ends
    if (base >= vacationStart && base <= vacationEnd) {

        let newClose = new Date(vacationEnd);

        // move forward to next Friday
        const daysUntilFriday = (CYCLE_CLOSE.day - newClose.getDay() + 7) % 7 || 7;
        newClose.setDate(newClose.getDate() + daysUntilFriday);
        newClose.setHours(CYCLE_CLOSE.hour, 0, 0, 0);

        return newClose;
    }

    return base;
    }


  function isStoreClosedRightNow(nowStore) {
    if (FORCE_SHIPPING_DATE) return false;
    // Block orders from Friday 12:00 AM to Friday 9:00 AM (store time)
    return (nowStore.getDay() === CYCLE_CLOSE.day && nowStore.getHours() < CYCLE_CLOSE.hour);
  }

  function computePickupKeysFromCycleClose(cycleClose) {
    // Friday pickup (same day as cycle close)
    const fridayDate = new Date(cycleClose);
    fridayDate.setHours(0, 0, 0, 0);

    // Sunday pickup (Friday + 2 days)
    const sundayDate = addDays(fridayDate, 2);
    sundayDate.setHours(0, 0, 0, 0);

    return {
      friday: toKeyYYYYMMDD(fridayDate),
      sunday: toKeyYYYYMMDD(sundayDate)
    };
  }

  function computeShippingKeyFromCycleClose(cycleClose) {
    if (FORCE_SHIPPING_DATE) return FORCE_SHIPPING_DATE;
    // Shipping date is Monday after close: Friday + 3 days
    const shipDate = addDays(cycleClose, 3);
    shipDate.setHours(0, 0, 0, 0);
    return toKeyYYYYMMDD(shipDate);
  }

  // Mystery Box: ships on the next upcoming Monday from store time.
  // Cutoff is Sunday 23:59 Miami — if purchased after that, ship moves to next Monday.
  // Holiday overrides apply (same map as standard shipping).
  function computeMysteryBoxShippingKey() {
    const now = getStoreTime();
    const dow = now.getDay(); // 0=Sun … 6=Sat
    // After Sunday midnight (i.e. Monday or later in the week) → push to next Monday
    let daysUntilMonday;
    if (dow === 0) {
      daysUntilMonday = 1; // Sunday → tomorrow
    } else {
      daysUntilMonday = (1 - dow + 7) % 7;
      if (daysUntilMonday === 0) daysUntilMonday = 7; // Monday/today → next Monday
    }
    const shipDate = addDays(now, daysUntilMonday);
    shipDate.setHours(0, 0, 0, 0);
    let key = toKeyYYYYMMDD(shipDate);
    // Apply holiday override (same as standard shipping)
    key = applyHolidayOverride(key, 'shipping');
    return key;
  }

  function applyHolidayOverride(originalKey, method /* 'shipping'|'pickup' */) {
    const ov = HOLIDAY_OVERRIDES[originalKey];
    if (!ov) return originalKey;
    if (method === 'shipping' && ov.shipping) return ov.shipping;
    if (method === 'pickup' && ov.pickup) return ov.pickup;
    return originalKey;
  }

  function getNextDates() {
    const now = getStoreTime();
    const cycleClose = getCycleClose(now);

    const cycleCloseKey = toKeyYYYYMMDD(cycleClose);

    // Determine availability per cycle
    const pickupOverride = PICKUP_OVERRIDES[cycleCloseKey];
    const fridayPickupAvailable  = pickupOverride ? pickupOverride.friday !== false : true;
    const sundayPickupAvailable  = DISABLE_SUNDAY_PICKUP_ALWAYS ? false : (pickupOverride ? pickupOverride.sunday !== false : true);
    const pickupAvailable = fridayPickupAvailable || sundayPickupAvailable;
    const shippingAvailable = !DISABLE_SHIPPING_THIS_WEEK && !DISABLE_SHIPPING_FOR_CYCLE_CLOSE.includes(cycleCloseKey);

    // Compute pickup keys (friday + sunday, only if available)
    let pickupKeys = null;
    if (pickupAvailable) {
      const raw = computePickupKeysFromCycleClose(cycleClose);

      // Apply holiday overrides per day
      raw.friday = applyHolidayOverride(raw.friday, 'pickup');
      raw.sunday = applyHolidayOverride(raw.sunday, 'pickup');

      pickupKeys = {};
      if (fridayPickupAvailable) {
        pickupKeys.friday = {
          key:     raw.friday,
          display: getFormattedDateParts(parseKeyToDate(raw.friday)).displayText + ' · 12–6 PM'
        };
      }
      if (sundayPickupAvailable) {
        pickupKeys.sunday = {
          key:     raw.sunday,
          display: getFormattedDateParts(parseKeyToDate(raw.sunday)).displayText + ' · 12–2 PM'
        };
      }
    }

    // Compute shipping key
    let shippingKey = shippingAvailable ? computeShippingKeyFromCycleClose(cycleClose) : null;
    if (shippingKey) shippingKey = applyHolidayOverride(shippingKey, 'shipping');

    const shippingDisplay = shippingKey
      ? getFormattedDateParts(parseKeyToDate(shippingKey)).displayText
      : null;

    return {
      now,
      cycleClose,
      cycleCloseKey,
      pickupAvailable,
      shippingAvailable,
      pickupKeys,
      shippingKey,
      shippingDisplay
    };
  }

  // =========================
  // CART RULES (validation + UI)
  // =========================

  function validateCartItems() {
    $.getJSON('/cart.js', function (cart) {
     try {
      // Guard: if the cart response is malformed (e.g. after removing the last
      // item Dawn may return an unexpected shape), bail out cleanly instead of
      // throwing — a throw here would break Dawn's PubSub subscriber chain and
      // leave the checkout button permanently disabled.
      if (!cart || !Array.isArray(cart.items)) { return; }

      let cartHasCookies = false;
      let cartHasCinnamonRolls = false;
      let cartHasBox = false;
      let cookiesCount = 0;

      let cartHasShippingOnly = false;
      let cartHasPickupOnly = false;
      let cartHasMysteryBox = false;
      let cartHasNonMystery = false;
      let cartHasPopupEvent = false;
      let cartHasNonPopup = false;
      let looseComponent = false;

      $('.custom-cart-rolls-msg').hide();
      $('.custom-cart-qty-msg').hide();

      // Reset: enable options first if present
      const shipSelect = $('.shipping-method-tybo');
      if (shipSelect.length) {
        shipSelect.find('option').prop('disabled', false);
      }

      cart.items.forEach(function (item) {

        const isExempt = isBoxProduct(item); // boxes never trigger the min-cookies rule

        // Bundle component present WITHOUT Simple Bundles grouping = bought loose.
        // Simple Bundles stamps a "_ce_id" / "_bundleId" style property on bundled lines.
        if ((item.handle || '').indexOf('component-') === 0 || item.product_type === 'Bundle Component') {
          const props = item.properties || {};
          let grouped = false;
          for (const k in props) {
            if (/bundle|_ce_|_box_id|_ro_|component/i.test(k) && props[k]) { grouped = true; break; }
          }
          if (!grouped) { looseComponent = true; item.__looseComponent = true; }
        }

        if (item.product_type === 'Cookies' && !isExempt) {
          cookiesCount += item.quantity;
          cartHasCookies = true;
        }

        if (item.product_type === 'Breads & Buns') {
          cartHasCinnamonRolls = true;
        }

        if (item.product_type === 'Box' && !isExempt) {
          cartHasBox = true;
        }

        // Track Mystery Box presence vs other items (for ship-date override when only MB)
        if (item.handle === 'mystery-box') {
          cartHasMysteryBox = true;
        } else {
          cartHasNonMystery = true;
        }

        // Track popup-event presence vs other items (for fixed-date selector when only popup)
        if (POPUP_EVENT_HANDLES.includes(item.handle)) {
          cartHasPopupEvent = true;
        } else {
          cartHasNonPopup = true;
        }

        // Shipping-only detection
        if (SHIPPING_ONLY_HANDLES.includes(item.handle)) {
          cartHasShippingOnly = true;

          const row = $('.cart-item__name[href*="' + item.handle + '"]').closest('td.cart-item__details');
          if (row.length && !row.find('.shipping-only-product-msg').length) {
            row.append(
              '<div class="shipping-only-product-msg" style="margin-top:6px;font-size:1rem;color:#b45309;background:#fff3cd;border:1px solid #ffe69c;padding:4px 6px;border-radius:4px;">This product is only available for <strong>SHIPPING</strong>.</div>'
            );
          }
          // Mystery Box ship date hint (next upcoming Monday, cutoff Sun 23:59 Miami).
          // Only for mystery-box (not for testbox or future shipping-only items that follow cycle rules).
          if (row.length && !row.find('.shipping-only-date-msg').length && item.handle === 'mystery-box') {
            const mbKey = computeMysteryBoxShippingKey();
            const mbDisplay = getFormattedDateParts(parseKeyToDate(mbKey)).displayText;
            row.append(
              '<div class="shipping-only-date-msg" style="margin-top:6px;font-size:1rem;color:#0f5132;background:#d1e7dd;border:1px solid #badbcc;padding:4px 6px;border-radius:4px;">This box will ship on <strong>' + mbDisplay + '</strong>.</div>'
            );
          }
        }

        // Pickup-only detection
        if (PICKUP_ONLY_HANDLES.includes(item.handle)) {
          // Popup-event items only force Pickup when alone (handled via TYBO_ONLY_POPUP).
          // Regular pickup-only items force Pickup whenever present.
          if (!POPUP_EVENT[item.handle]) {
            cartHasPickupOnly = true;
          }

          const row = $('.cart-item__name[href*="' + item.handle + '"]').closest('td.cart-item__details');
          if (row.length && !row.find('.pickup-only-product-msg').length) {
            const ev = POPUP_EVENT[item.handle];
            const loc = ev ? ev.location : '11913 Hometown Place Orlando, FL';
            // Pop-up event: single combined message (location + fixed date)
            const msg = ev
              ? 'This product is only available for <strong>PICK UP</strong> at ' + ev.location + ' on <strong>' + ev.dateDisplay + '</strong>.'
              : 'This product is only available for <strong>PICK UP</strong> at ' + loc + '.';
            row.append(
              '<div class="pickup-only-product-msg" style="margin-top:6px;font-size:1rem;color:#b45309;background:#fff3cd;border:1px solid #ffe69c;padding:4px 6px;border-radius:4px;">' + msg + '</div>'
            );
          }
        }

        // Warm-weather warning (per-handle)
        if (WARM_WEATHER_WARNING_HANDLES.includes(item.handle)) {
          const row = $('.cart-item__name[href*="' + item.handle + '"]').closest('td.cart-item__details');
          if (row.length && !row.find('.product-warning-msg').length) {
            row.append(
              '<div class="product-warning-msg" style="margin-top:6px;font-size:1rem;color:#b45309;background:#fff3cd;border:1px solid #ffe69c;padding:4px 6px;border-radius:4px;">' + WARM_WEATHER_WARNING_MSG + '</div>'
            );
          }
        }

        // Loose bundle component (roll flavor added on its own) → per-row notice
        if (item.__looseComponent) {
          const rowLoose = $('.cart-item__name[href*="' + item.handle + '"]').closest('td.cart-item__details');
          if (rowLoose.length && !rowLoose.find('.not-sold-individually-msg').length) {
            rowLoose.append(
              '<div class="not-sold-individually-msg" style="margin-top:6px;font-size:1rem;color:#b45309;background:#fff3cd;border:1px solid #ffe69c;padding:4px 6px;border-radius:4px;">This product is not sold individually. Roll flavors are only available as part of a Cinnamon Roll box.</div>'
            );
          }
        }
      });

      // Minimum cookies rule
      if ((cartHasCookies || cartHasBox) && cookiesCount < 4) {
        $('.custom-cart-qty-msg').show();
      }

      // Cinnamon rolls rule (your original behavior)
      if (cartHasCinnamonRolls) {
        $('.custom-cart-rolls-msg').show();
        // If you still want to disable a specific option index, keep your original logic,
        // but it is fragile. We'll avoid index-based disables here.
      }

      // Apply method forcing rules
      window.TYBO_SHIPPING_ONLY = cartHasShippingOnly;
      window.TYBO_PICKUP_ONLY = cartHasPickupOnly;
      // Cart contains ONLY Mystery Box (no other items) → ship-date selector should use MB rule
      window.TYBO_ONLY_MYSTERY_BOX = cartHasMysteryBox && !cartHasNonMystery;
      // Cart contains ONLY popup-event item(s) → date selector uses the fixed event date
      window.TYBO_ONLY_POPUP = cartHasPopupEvent && !cartHasNonPopup;
      window.__bbLooseComponent = looseComponent;

      // Update method dropdown options (avoid duplicates)
      function ensureOption(select, value, label) {
        if (!select.find('option[value="' + value + '"]').length) {
          select.append('<option value="' + value + '">' + label + '</option>');
        }
      }

      function removeOption(select, value) {
        select.find('option[value="' + value + '"]').remove();
      }

      if (shipSelect.length) {
        // Ensure both exist first (Shipping only if not globally disabled this week)
        if (!DISABLE_SHIPPING_THIS_WEEK) ensureOption(shipSelect, 'Shipping', 'Shipping');
        ensureOption(shipSelect, 'Pickup', 'Pickup');

        // GLOBAL: no Shipping this week -> force Pickup for everything.
        if (DISABLE_SHIPPING_THIS_WEEK) {
          removeOption(shipSelect, 'Shipping');
          if (shipSelect.val() !== 'Pickup') shipSelect.val('Pickup');
          $('.tybo-shipping-terms').hide();
        }

        if (!DISABLE_SHIPPING_THIS_WEEK && cartHasShippingOnly) {
          removeOption(shipSelect, 'Pickup');
          // No .trigger('change') here: refreshDateOptions() is called below once.
          if (shipSelect.val() !== 'Shipping') shipSelect.val('Shipping');
          $('.pickup-time-tybo-cont, .pickup-availability, pickup-availability, .cart__pickup-availability').hide();
        }

        // Force Pickup for regular pickup-only items, OR when the cart has ONLY the popup item
        if (cartHasPickupOnly || window.TYBO_ONLY_POPUP) {
          removeOption(shipSelect, 'Shipping');
          if (shipSelect.val() !== 'Pickup') shipSelect.val('Pickup');
          $('.tybo-shipping-terms').hide();
        }

        // If neither forced, ensure both exist
        if (!DISABLE_SHIPPING_THIS_WEEK && !cartHasShippingOnly && !cartHasPickupOnly && !window.TYBO_ONLY_POPUP) {
          ensureOption(shipSelect, 'Shipping', 'Shipping');
          ensureOption(shipSelect, 'Pickup', 'Pickup');
        }

        // GLOBAL: shipping only -> never offer Pickup (wins over everything above)
        if (DISABLE_PICKUP_ALWAYS) {
          ensureOption(shipSelect, 'Shipping', 'Shipping');
          removeOption(shipSelect, 'Pickup');
          if (shipSelect.val() !== 'Shipping') shipSelect.val('Shipping');
          $('.pickup-time-tybo-cont, .pickup-availability, pickup-availability, .cart__pickup-availability').hide();
        }
      }

      // After cart validation, refresh the single-date options based on cycle engine
      refreshDateOptions();
      syncShippingTermsVisibility();
     } catch (err) {
      // Never let a cart-validation error break the rest of the page.
      if (window.console) console.warn('validateCartItems error:', err);
     }
    });
  }

  // =========================
  // SINGLE-DATE OPTIONS (no calendar)
  // =========================

  function refreshDateOptions() {
    const data = getNextDates();

    // If pickup/shipping are disabled by cycle, reflect in the method selector
    const shipSelect = $('.shipping-method-tybo');
    if (shipSelect.length) {
      // If pickup is disabled for this cycle, remove it
      if (!data.pickupAvailable) {
        shipSelect.find('option[value="Pickup"]').remove();
        if (shipSelect.val() === 'Pickup') shipSelect.val('Shipping');
        $('.pickup-time-tybo-cont').hide();
      }

      // If shipping is disabled for this cycle, remove it
      if (!data.shippingAvailable) {
        shipSelect.find('option[value="Shipping"]').remove();
        if (shipSelect.val() === 'Shipping') shipSelect.val('Pickup');
      }

      // If both are available, ensure they exist — but respect per-product method forcing
      // (don't re-add an option that validateCartItems removed for shipping-only / pickup-only carts)
      if (!DISABLE_PICKUP_ALWAYS && data.pickupAvailable && !window.TYBO_SHIPPING_ONLY && !shipSelect.find('option[value="Pickup"]').length) {
        shipSelect.append('<option value="Pickup">Pickup</option>');
      }
      if (data.shippingAvailable && !window.TYBO_PICKUP_ONLY && !window.TYBO_ONLY_POPUP && !shipSelect.find('option[value="Shipping"]').length) {
        shipSelect.append('<option value="Shipping">Shipping</option>');
      }

      // Re-enforce method forcing after refresh (keeps Shipping hidden when pickup-only, etc.)
      if (window.TYBO_PICKUP_ONLY || window.TYBO_ONLY_POPUP) {
        shipSelect.find('option[value="Shipping"]').remove();
        if (shipSelect.val() !== 'Pickup') shipSelect.val('Pickup');
      }
      if (window.TYBO_SHIPPING_ONLY || DISABLE_PICKUP_ALWAYS) {
        if (!shipSelect.find('option[value="Shipping"]').length) shipSelect.append('<option value="Shipping">Shipping</option>');
        shipSelect.find('option[value="Pickup"]').remove();
        if (shipSelect.val() !== 'Shipping') shipSelect.val('Shipping');
        $('.pickup-time-tybo-cont').hide();
      }
    }

    // Populate the "date" selector with exactly one option depending on method
    // (Your element is #tybo-shipping-date; keep the id to avoid template changes.)
    const dateSelect = $('#tybo-shipping-date');
    if (!dateSelect.length) return;

    const selectedMethod = $('.shipping-method-tybo').val();

    dateSelect.empty();
    dateSelect.append($('<option>', { value: '', text: 'Please select' }));

    if (selectedMethod === 'Shipping') {
      if (!data.shippingAvailable || !data.shippingKey) {
        dateSelect.append($('<option>', { value: '', text: 'Shipping temporarily unavailable' }));
        dateSelect.prop('disabled', true);
      } else {
        // If cart contains ONLY Mystery Box, override with MB-specific ship date
        let shipKey = data.shippingKey;
        let shipDisplay = data.shippingDisplay;
        if (window.TYBO_ONLY_MYSTERY_BOX) {
          shipKey = computeMysteryBoxShippingKey();
          shipDisplay = getFormattedDateParts(parseKeyToDate(shipKey)).displayText;
        }
        dateSelect.append($('<option>', { value: shipKey, text: shipDisplay }));
        dateSelect.prop('disabled', false);
        // Update the .next-monday hint inside .shipping-terms too
        $('.next-monday').text(shipDisplay);
      }
    } else if (selectedMethod === 'Pickup') {
      if (!data.pickupAvailable || !data.pickupKeys) {
        dateSelect.append($('<option>', { value: '', text: 'Pickup temporarily unavailable' }));
        dateSelect.prop('disabled', true);
        $('.pickup-time-tybo-cont').hide();
      } else if (window.TYBO_ONLY_POPUP) {
        // Cart has ONLY the popup-event item → single fixed event date (Haus Eleven)
        const ev = POPUP_EVENT[POPUP_EVENT_HANDLES[0]];
        dateSelect.append($('<option>', { value: ev.dateKey, text: ev.dateDisplay }));
        dateSelect.prop('disabled', false);
        $('.pickup-time-tybo-cont').hide();
      } else {
        // Friday option (only if available)
        if (data.pickupKeys.friday) {
          dateSelect.append($('<option>', {
            value: data.pickupKeys.friday.key,
            text:  data.pickupKeys.friday.display
          }));
        }
        // Sunday option (only if available)
        if (data.pickupKeys.sunday) {
          dateSelect.append($('<option>', {
            value: data.pickupKeys.sunday.key,
            text:  data.pickupKeys.sunday.display
          }));
        }
        dateSelect.prop('disabled', false);
        // No individual time selector — hide it
        $('.pickup-time-tybo-cont').hide();
      }
    } else {
      // No method selected
      dateSelect.prop('disabled', true);
    }

    // Optional: show a readable hint somewhere if you have .next-monday
    // Keep consistent with your UI; here we show the shipping date label.
    if (data.shippingKey) {
      $('.next-monday').text(data.shippingDisplay || data.shippingKey);
    }
  }

  // =========================
  // EVENTS
  // =========================

  // Initial run
  validateCartItems();

  // Re-validate when cart changes via theme's PubSub events
  // (Dawn-based themes publish 'cart-update' and 'quantity-update' after AJAX cart mutations.)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      validateCartItems();
    });
    subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
      validateCartItems();
    });
  }

  // Fallback: also re-validate on click of remove / qty buttons (event delegation so it survives DOM replace)
  $('body').on('click', '.btn-cart-remove-item, .quantity__button, cart-remove-button', function () {
    $('.custom-tybo-checkout').prop('disabled', true);
    setTimeout(function () {
      try { validateCartItems(); }
      finally {
        // Re-select the button: Dawn may have re-rendered <cart-items>, so the
        // old node is gone. Always re-enable, even if validation threw.
        $('.custom-tybo-checkout').prop('disabled', false);
      }
    }, 800);
  });

  // Fallback extra: any change on quantity inputs
  $('body').on('change', '.quantity__input, input[name="updates[]"]', function () {
    setTimeout(validateCartItems, 800);
  });

  // Keep the shipping-terms block (with its checkbox) in sync with the CURRENT
  // method — not only on 'change'. Fixes: cart loads with Shipping preselected,
  // checkbox never shown, checkout blocked by an invisible requirement.
  function syncShippingTermsVisibility() {
    const method = $('.shipping-method-tybo').val();
    if (method === 'Shipping' && !DISABLE_SHIPPING_THIS_WEEK) {
      $('.shipping-terms').show();
    } else {
      $('.shipping-terms').hide();
      $('.tybo-shipping-terms').hide();
    }
  }

  // When method changes, refresh the single date option
  $('body').on('change', '.shipping-method-tybo', function () {
    // Reset date
    $('.tybo-date-input').val('');
    refreshDateOptions();

    const selected = $(this).val();
    if (selected === 'Pickup') {
      $('.pickup-time-tybo-cont').hide();   // no individual time picker — range shown in date label
      $('.shipping-terms').hide();
      $('.tybo-shipping-terms').hide();
    } else if (selected === 'Shipping') {
      $('.pickup-time-tybo-cont').hide();
      $('.shipping-terms').show();
    }
  });

  // Enable/disable pickup time depending on date selection (kept minimal)
  $('body').on('change', '#tybo-shipping-date', function () {
    const selectedDate = $(this).val();
    const method = $('.shipping-method-tybo').val();
    if (method === 'Pickup') {
      $('.pickup-time-tybo').prop('disabled', !selectedDate);
    }
  });

  // =========================
  // CHECKOUT VALIDATION (single gate)
  // =========================

  $('body').on('click', '.custom-tybo-checkout', function () {

    // Hide validations
    $('.tybo-qty-validation').hide();
    $('.tybo-shipping-validation').hide();
    $('.tybo-pickup-time-validation').hide();

    const now = getStoreTime();

    // Hard block: Friday 12:00 AM → 3:00 PM
    if (isStoreClosedRightNow(now)) {
      alert('Orders are temporarily closed. New orders open today at 9 AM (Miami time).');
      return;
    }

    const shippingMethod = $('.shipping-method-tybo').val();
    const shippingDate = $('#tybo-shipping-date').val() || $('.tybo-date-input').val() || false;
    const pickupTime = $('.pickup-time-tybo').val();

    // Bundle components can't be bought on their own. If a [COMPONENT] product
    // is in the cart WITHOUT Simple Bundles' grouping property, block checkout.
    if (window.__bbLooseComponent) {
      alert('Individual roll flavors can only be ordered as part of a Cinnamon Roll box. Please remove them and build your box.');
      return;
    }

    // Enforce shipping-only and pickup-only veto
    // (skip the shipping-only veto when Shipping is globally disabled this week)
    if (!DISABLE_SHIPPING_THIS_WEEK && window.TYBO_SHIPPING_ONLY && shippingMethod === 'Pickup') {
      alert('One or more items in your cart are available for shipping only. Please choose Shipping as your delivery method or remove the products to continue.');
      return;
    }
    if (window.TYBO_PICKUP_ONLY && shippingMethod === 'Shipping') {
      alert('One or more items in your cart are available for pickup only. Please choose Pickup as your delivery method or remove the products to continue.');
      return;
    }
    if (window.TYBO_ONLY_POPUP && shippingMethod === 'Shipping') {
      alert('This pre-order is only available for pickup at the pop-up event. Please choose Pickup to continue.');
      return;
    }

    // Validate cart minimums (same rule, centralized)
    $.getJSON('/cart.js', function (cart) {

      let cartHasCookies = false;
      let cartHasBox = false;
      let cookiesCount = 0;

      cart.items.forEach(function (item) {
        const isExempt = isBoxProduct(item); // boxes never trigger the min-cookies rule

        if (item.product_type === 'Cookies' && !isExempt) {
          cookiesCount += item.quantity;
          cartHasCookies = true;
        }
        if (item.product_type === 'Box' && !isExempt) {
          cartHasBox = true;
        }
      });

      if ((cartHasCookies || cartHasBox) && cookiesCount < 4) {
        $('.tybo-qty-validation').show();
        return;
      }

      if (!shippingMethod || !shippingDate) {
        $('.tybo-shipping-validation').show();
        return;
      }

      // (No individual pickup time selector — time range is shown in the date label)

      if (shippingMethod === 'Shipping' && !$("#agree-shipping").is(":checked")) {
        $('.shipping-terms').show(); // make sure the checkbox itself is visible
        $('.tybo-shipping-terms').show();
        return;
      }

      // Persist attributes to Shopify cart
      const attributes = {
        'Shipping Method': shippingMethod,
        'Pickup Date':     shippingMethod === 'Pickup'    ? shippingDate : null,
        'Shipping Date':   shippingMethod === 'Shipping'  ? shippingDate : null
      };

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { attributes },
        dataType: 'json',
        success: function () {
          window.location.href = '/checkout';
        }
      });

    });

  });

  // =========================
  // CLOSED-WINDOW UI (disable Check out during Friday 00:00–09:00 Miami)
  // =========================
  (function initClosedWindowUI(){
    // Inject styles once
    if (!document.getElementById('tybo-closed-style')) {
      const s = document.createElement('style');
      s.id = 'tybo-closed-style';
      s.textContent = '.custom-tybo-checkout:disabled,.custom-tybo-checkout.is-store-closed{background-color:#9ca3af !important;color:#fff !important;cursor:not-allowed;opacity:1;}';
      document.head.appendChild(s);
    }

    const CLOSED_TEXT = 'Closed — opens Friday 9 AM (Miami)';

    function applyClosedState() {
      const $btn = $('.custom-tybo-checkout');
      if (!$btn.length) return;
      const closed = isStoreClosedRightNow(getStoreTime());
      if (closed) {
        if (!$btn.data('tybo-original-text')) {
          $btn.data('tybo-original-text', $btn.text());
        }
        $btn.prop('disabled', true).addClass('is-store-closed').text(CLOSED_TEXT);
      } else {
        const original = $btn.data('tybo-original-text');
        if ($btn.hasClass('is-store-closed')) {
          $btn.prop('disabled', false).removeClass('is-store-closed');
          if (original) $btn.text(original);
        }
      }
    }

    applyClosedState();
    setInterval(applyClosedState, 60000);
  })();

  // =========================
  // INITIAL DATE OPTIONS
  // =========================
  refreshDateOptions();

});



